export default "__VITE_ASSET__CRfpFMMk__"